// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"87":"2dfe6577","324":"bf12a999","360":"13e2a61d","385":"0285f444","629":"6872bf20","684":"4671f970","773":"180f9697","825":"e146f484","893":"ddbced11"}[chunkId] + ".js";
};